import React from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import * as types from '../../reducer/constants';

const FieldCancel = ({ form, dispatchServiceData }) => {
  const { cancel } = form;
  const selectedValue = cancel ? '1' : '0';

  const onChange = (e) => {
    const value = e.target.value === '1';
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_CANCEL, value })
  };

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="cancel">Cancel</ControlLabel>
        <select name="cancel" id="cancel" className="form-control" value={selectedValue} onChange={onChange}>
          <option value="1">Allow</option>
          <option value="0">Disallow</option>
        </select>
      </FormGroup>
    </>
  );
};

FieldCancel.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldCancel;
